import request from '@/utils/request'

// 获取保司列表
export const getCompany = () => {
  return request.post(`/story/file/companies`)
}
// 文件知识拆分知识块
export const fileSplit = (params) => {
  return request.post(`/story/file/split`, params)
}
// 获取外接知识库
export const getKnowledge = () => {
  return request.post(`/story/file/knowledge/list`)
}
// 获取外接知识库详情
export const getKnowledgeDetail = (params) => {
  return request.post(`/story/file/knowledge/split/${params.id}`)
}
// 保存
export const knowledgeSave = (params) => {
  return request.post(`/story/file/save`, params)
}
// --------------------------------
// taskBaseList
export const taskBaseList = (params) => {
  return request.post(`/task_base/list`, params)
}
// 选择知识文件+对应知识块
export const fileList = (params) => {
  return request.post(`/story/file/list`)
}
// 删除task
export const delTask = (params) => {
  return request.post(`/task_base/delete/${params.id}`)
}
// 生成task合集及taskBase
export const taskBaseGenerate = (params) => {
  return request.post(`/task_base/generate`, params)
}
// 查看task-base下的taskList
export const base_taskList = (params) => {
  return request.post(`/task_base/detail/${params.id}`)
}

// 知识列表
export const queryKnowledge = (params) => {
  return request.post(`/story/file/page`, params)
}
// 知识del
export const knowledgeDel = (params) => {
  return request.post(`/story/file/delete/${params.id}`)
}
